import { defineStore } from 'pinia';
import Network from "~/utils/network";
import i18n, { i18nInstance } from '~~/plugins/i18n';

const urls = {
  allDeal: '/bnpl/my-deal',
  upcomingTransactions: '/bnpl/transaction/upcoming',
};

export const useSelfcareStore = defineStore('selfcare', {
  state: () => ({
    financer: '',
    loaded: false,
    breadcrumb: {
      items: [],
    },
    activePage: "dashboard",
    previousPage: 'dashboard',
    activePurchase: null,
    activeTransaction: null,
    activeTodo: null,
    deals: [],
    activePays: [],
    pages: {
      "dashboard": {
        name: "bnpl:selfcare.menu.dashboard.name",
        desc: "bnpl:selfcare.menu.dashboard.description",
        icon: "gear",
        showInMenu: true,
        hasTokens: true,
      },
      "purchases": {
        name: "bnpl:selfcare.menu.purchases.name",
        desc: "bnpl:selfcare.menu.purchases.description",
        icon: "basket-shopping",
        showInMenu: true,
        hasTokens: true,
      },
      "todos": {
        name: "bnpl:selfcare.menu.todos.name",
        desc: "bnpl:selfcare.menu.todos.description",
        icon: "clipboard-list",
        showInMenu: true,
        hasTokens: true,
      },
      "profile-settings": {
        name: "bnpl:selfcare.menu.profile-settings.name",
        desc: "bnpl:selfcare.menu.profile-settings.description",
        icon: "user",
        showInMenu: true,
        hasTokens: true,
      },
      "help": {
        name: "bnpl:selfcare.menu.help.name",
        desc: "bnpl:selfcare.menu.help.description",
        icon: "question",
        showInMenu: true,
        hasTokens: true,
      },
      "payment": {
        name: "bnpl:selfcare.menu.payment.name",
        showInMenu: false,
        hasTokens: true,
      },
      "limit": {
        name: "bnpl:selfcare.menu.limit.name",
        desc: "bnpl:selfcare.menu.limit.description",
        icon: "clock",
        showInMenu: true,
        hasTokens: true,
      },
      "rewards": {
        name: "bnpl:selfcare.menu.rewards.name",
        desc: "bnpl:selfcare.menu.rewards.description",
        icon: "gift",
        showInMenu: true,
        hasTokens: true,
      },
      "coupon": {
        name: "bnpl:selfcare.menu.coupon.name",
        desc: "bnpl:selfcare.menu.coupon.description",
        icon: "ticket-simple",
        showInMenu: true,
        hasTokens: true,
      },
    },
    isPaymentPartial: false,
  }),
  actions: {
    navigateTo(pageId, deleteActives = true) {
      this.previousPage = this.activePage;
      scroll(0, 0);
      if (deleteActives) {
        this.activePurchase = null;
        this.activeTransaction = null;
        this.activeTodo = null;
      }
      this.activePage = pageId;
      if (this.pages[pageId]) {
        this.breadcrumb.items = [i18nInstance.global.t(this.pages[pageId].name)];
      }
    },
    openTodo(todo) {
      scroll(0, 0);
      this.activeTodo = todo;
      this.breadcrumb.items.push("Teendő");
    },
    openPurchase(deal) {
      scroll(0, 0);
      this.activePurchase = deal;
      this.breadcrumb.items.push(i18nInstance.global.t("bnpl:breadcrumb.purchase") + " " + i18nInstance.global.d(deal.created, "numeric"));
    },
    async loadEverything() {
      await this.fetchDeals();
      await this.fetchActivePays();
      if (this.activePurchase) {
        this.activePurchase = this.deals.find((d) => d.id === this.activePurchase.id);
      }
      this.loaded = true;
    },
    async fetchDeals() {
      let allDeal = await Network.http(urls.allDeal);
      this.deals = allDeal.filter((deal) => deal.applicationStatus !== "INITIAL").sort((d1, d2) => new Date(d2.created) - new Date(d1.created));
    },
    async fetchActivePays() {
      let activePays = await Network.http(urls.upcomingTransactions);
      this.activePays = activePays.sort((d1, d2) => new Date(d2.created) - new Date(d1.created));
    }
  }
});
